export default "__VITE_ASSET__DRhEtE_f__"